export default {
    heading: 'Gilroy-Bold',
    body: 'ProximaNova'
}